<template>
  <loading-page v-if="fetchingBuckets || gettingLiveJobModel" />
  <div
    v-else
    ref="gjWizard"
    class="gj-wizard gj-wizard-full-height"
  >
    <form-wizard
      ref="liveJobFom"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      :class="{ blurred: noDestinations && !externalAccounts.length > 0 }"
      @on-change="wizardToTop"
      @on-complete="createJob"
    >
      <!-- input settings tab -->
      <tab-content
        title="Input/Output Settings"
        :before-change="validateInputSettings"
      >
        <validation-observer
          ref="inputSettingsRules"
          v-slot="{ errors }"
        >
          <b-row class="justify-content-center">
            <b-col
              cols="12"
              md="10"
            >
              <paper-simple class="pb-1">
                <!-- <custom-input-radio
                  id="input_type"
                  v-model="liveJobModel.input.serverType"
                  md-cols="4"
                  label="Select the Input type"
                  :options="
                    getServerTypeOptions(liveJobModel.input.serverTypeOptions)
                  "
                />
                <validation-provider
                  #default="{ errors }"
                  name="Input Name"
                  rules="required"
                >
                  <input-field
                    name="input_class"
                    label="Input Class"
                    label-position="top"
                    :error="errors.length ? errors[0] : null"
                  >
                    <custom-select
                      id="input_class"
                      v-model="liveJobModel.input.inputClass"
                      :options="
                        getOptions(liveJobModel.input.inputClassOptions)
                      "
                    />
                  </input-field>
                </validation-provider> -->
                <div class="mb-2">
                  <input-field
                    name="create_job-destination"
                    label="Destination*"
                    label-position="top"
                    class="mr-35 mw-100"
                    :error="errors.Destination ? errors.Destination[0] : errors.bucket ? errors.bucket[0] : 'No Bucket & Destinations'"
                  >
                    <b-input-group class="mw-100">
                      <transition name="fade">
                        <div v-if="!noDestinations || externalAccounts.length > 0">
                          <validation-provider
                            #default="{ errors }"
                            name="account"
                            tag="div"
                            class="w-100"
                            immediate
                          >
                            <b-dropdown
                              id="object-options"
                              :disabled="fetchingExternalAccounts && fetchingAccountBuckets"
                              variant="bg-white"
                              offset="20"
                              no-caret
                              :state="errors.length > 0 ? false : null"
                              @show="isOpenExternalAccount = true"
                              @hide="isOpenExternalAccount = false"
                            >
                              <template
                                #button-content
                              >
                                <div v-if="selectedAccount">
                                  <img
                                    :src="selectedAccount.parentId === '0' ? require('@/assets/images/logo/Captain.svg') : selectedAccount.providerImageUrl"
                                    width="30px"
                                    height="30px"
                                    alt="Storage External Account"
                                    class="mr-1"
                                  >
                                  <span><b>{{ selectedAccount.parentId === '0' ? 'Captain' : selectedAccount.username }}</b></span>
                                  <GjIcon
                                    class="ml-1"
                                    :class="isOpenExternalAccount ? 'arrow' : 'arrow-down'"
                                    name="ArrowDown"
                                  />
                                </div>
                              </template>
                              <ul
                                v-for="(account, property) in externalAccounts"
                                :key="property"
                                class="list-unstyled m-0 p-0"
                              >
                                <b-dropdown-item @click="changeSelectedAccount(account)">
                                  <img
                                    :src="account.parentId === '0' ? require('@/assets/images/logo/Captain.svg') : account.providerImageUrl"
                                    width="30px"
                                    height="30px"
                                    alt=""
                                    class="mr-1"
                                  >
                                  <span class="main"><strong>{{ account.parentId === '0' ? 'Captain ' : account.username }}</strong></span>
                                </b-dropdown-item>
                              </ul>
                            </b-dropdown>
                          </validation-provider>
                        </div>
                      </transition>
                      <transition name="fade">
                        <div v-if="!noDestinations || externalAccounts.length > 0">
                          <validation-provider
                            #default="{ errors }"
                            name="bucket"
                            tag="div"
                            class="w-100"
                            immediate
                          >
                            <custom-select
                              id="live-job-bucket"
                              v-model="selectedBucket"
                              class="bucket-input"
                              label="name"
                              :loading="fetchingAccountBuckets || fetchingExternalAccounts"
                              :disabled="!!selectedAccount.bucketName"
                              :state="errors.length > 0 ? false:null"
                              :options="getBucketOptions(accountBuckets)"
                            />
                          </validation-provider>
                        </div>
                      </transition>
                      <b-input-group-prepend class="flex-fill mw-100">
                        <span class="destination-split">/</span>

                        <validation-provider
                          #default="{ errors }"
                          name="Destination"
                          rules="validateForwardSlash"
                          tag="div"
                          class="w-100"
                        >
                          <b-form-input
                            v-model="liveJobModel.destination"
                            placeholder="Enter file destination..."
                            :state="errors.length > 0 ? false : null"
                            style="min-width: 150px;"
                          />
                        </validation-provider>
                      </b-input-group-prepend>
                    </b-input-group>
                  </input-field>
                </div>
                <input-field
                  name="create_job-destination"
                  label="Callback URL"
                  label-position="top"
                  :info="{
                    title: 'Callback Response JSON',
                    content: callbackResponse,
                  }"
                  @openInfo="viewJson"
                >
                  <b-form-input
                    id="create_job-destination"
                    v-model="liveJobModel.input.callbackUrl"
                    placeholder="Enter callback URL..."
                  />
                </input-field>
                <input-field
                  label="Description"
                  label-position="top"
                  class="mt-1 mr-35"
                >
                  <b-form-input
                    v-model="liveJobModel.description"
                    placeholder="Enter description here..."
                  />
                </input-field>
                <div class="d-flex mt-2 mb-1">
                  <b-form-group
                    label="LiveJob Pull"
                    class="mr-2 text-regular text-secondary field-label"
                  >
                    <b-form-checkbox
                      v-model="liveJobModel.streamType"
                      class="toggle-spacing "
                      switch
                    />
                  </b-form-group>
                  <b-form-group
                    label="Input Stream Recording"
                    class="mr-2 text-regular text-secondary field-label"
                  >
                    <b-form-checkbox
                      v-model="liveJobModel.record"
                      class="toggle-spacing "
                      switch
                    />
                  </b-form-group>
                  <b-form-group
                    label="Use Relay"
                    class="text-regular text-secondary field-label"
                  >
                    <b-form-checkbox
                      v-model="liveJobModel.hasRelay"
                      class="toggle-spacing "
                      switch
                    />
                  </b-form-group>
                </div>
                <div
                  v-if="liveJobModel.streamType"
                  class="d-flex flex-wrap mb-1"
                >
                  <input-field
                    label="Input"
                    label-position="top"
                    class="col-9 col-lg-11 pl-0 mr-1"
                  >
                    <b-form-input
                      v-model="liveJobModel.input.filePath"
                      placeholder="Enter input file URL here..."
                    />
                  </input-field>
                  <b-form-group
                    label="Auto Pull"
                    class="auto-pull-button text-regular text-secondary field-label"
                  >
                    <b-form-checkbox
                      v-model="liveJobModel.autoPull"
                      class="toggle-spacing col-3 col-lg-1"
                      switch
                    />
                  </b-form-group>
                </div>
                <transition name="fade">
                  <custom-input-radio
                    v-if="liveJobModel.record"
                    id="input_class"
                    v-model="liveJobModel.recordType"
                    class="mr-35"
                    label="Record Type"
                    format-camel-case
                    :options="getObjectOptions(liveJobModel.recordTypes)"
                    :info="generalInfo.recordtype"
                    @openInfo="openInfo"
                  />
                </transition>

                <custom-alert
                  icon-name="InfoAlt"
                  items-center
                  variant="light"
                  class="mr-35"
                >Every live job is recorded by default, disable Recording if
                  there is no need for a recorded asset.
                </custom-alert>
              </paper-simple>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <!-- encoder settings tab -->
      <tab-content
        title="Encoder Settings"
        :before-change="validateEncoderSettings"
      >
        <validation-observer ref="liveJobRules">
          <b-row class="justify-content-center">
            <b-col
              cols="12"
              md="10"
            >
              <paper title="Create Live Job">
                <div class="px-2 pb-1">
                  <b-row>
                    <b-col
                      cols="12"
                      md="8"
                    >
                      <input-field
                        name="create_job-template"
                        label="Job template*"
                        label-position="top"
                        :error="
                          jobTemplateError && selectedJobTemplate === null
                            ? 'Select a Job Template'
                            : null
                        "
                      >
                        <div
                          class="jobTemplateName border align-items-center d-flex text-break"
                          :class="{
                            'border-danger':
                              jobTemplateError && selectedJobTemplate === null,
                          }"
                        >
                          <span v-if="selectedJobTemplate">
                            {{ selectedJobTemplate.name }}
                          </span>
                          <div
                            v-else
                            class="text-muted italic"
                          >
                            Select a job template from below
                          </div>
                        </div>
                      </input-field>
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="align-self-center"
                    >
                      <a @click="setJobTemplate(selectedJobTemplate)">
                        <GjIcon name="Close" />
                        <span style="line-height: 23px;">Clear Template</span>
                      </a>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 mt-md-0">
                    <b-col>
                      <input-field
                        name="tags"
                        label="Tags"
                        label-position="top"
                      >
                        <tags
                          full-width
                          :tags="jobTags"
                          @remove-field="onRemoveField"
                        />
                      </input-field>
                    </b-col>
                  </b-row>
                </div>
              </paper>
            </b-col>
          </b-row>
          <b-row
            id="jobTemplates"
            class="justify-content-center"
          >
            <b-col
              cols="12"
              md="10"
            >
              <paper title="Job Template">
                <template v-slot:header-right>
                  <b-button
                    variant="outline-primary"
                    class="btn-paper-header"
                    @click="createJobTemplate"
                  >
                    New Job Template
                  </b-button>
                </template>
                <job-templates
                  live-encoder
                  :selected="selectedJobTemplate"
                  @selected="setJobTemplate"
                  @create="createJobTemplate"
                />
              </paper>
            </b-col>
          </b-row>
          <json-preview v-model="jsonToPreview" />
        </validation-observer>
      </tab-content>
      <!-- authorization settings -->
      <tab-content title="Authorization Settings">
        <b-row class="justify-content-center">
          <b-col
            cols="12"
            md="10"
          >
            <paper-simple>
              <encoder-authorization-settings v-model="liveJobModel" />
            </paper-simple>
          </b-col>
        </b-row>
      </tab-content>
      <template
        slot="footer"
        slot-scope="props"
      >
        <div class="wizard-custom-footer col-12 col-lg-9">
          <b-button
            variant="bg-white"
            class="mr-1"
            :class="props.activeTabIndex > 0 ? 'transparent' : ''"
            @click="onCancel()"
          >
            Cancel
          </b-button>
          <b-button
            v-if="props.activeTabIndex > 0"
            variant="bg-white"
            class="mr-1"
            @click="props.prevTab()"
          >
            Go Back
          </b-button>
          <b-button
            v-if="!props.isLastStep"
            :disabled="noDestinations && !externalAccounts.length > 0"
            class="wizard-footer-right"
            variant="bg-primary"
            @click="props.nextTab()"
          >
            Next
          </b-button>

          <button-loading
            v-else
            class="wizard-footer-right done-button"
            :spinning="creatingLiveJob"
            :disabled="!isJobTemplateSelected || creatingLiveJob"
            variant="bg-primary"
            @click="createJob"
          >Done</button-loading>
        </div>
      </template>
    </form-wizard>
    <pop-up
      v-if="noDestinations && !externalAccounts.length > 0"
      class="position-absolute bg-transparent"
      title="Create an External Account"
      button-text="Integrate Storage"
      :show-cancel="false"
      go-back
      @add="$router.push({ name: 'add-external-account' })"
      @goBack="$router.push({ name: 'live-encoder' })"
    >
      To be able to create a Live Job you need to have an External Account with a Bucket.
    </pop-up>
    <info
      v-if="infoData"
      :info="infoData"
      @close="infoData = null"
    />
  </div>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import PopUp from '@/components/popup/Pop-up.vue'
import EncoderAuthorizationSettings from '@/components/views/encoder/EncoderAuthorizationSettings.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import CustomInputRadio from '@/components/form/CustomInputRadio.vue'
import JsonPreview from '@/components/info/JsonPreview.vue'
import Tags from '@/components/tags/Tags.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { FormWizard, TabContent } from 'vue-form-wizard'
import JobTemplates from '../jobs/JobTemplates.vue'
import { callbackResponse } from '../jobs/code'
import { required, alphaDash } from '@validations'
import generalInfo from '../output-presets/generalInfo'

export default {
  name: 'CreateLiveJob',
  components: {
    Paper,
    CustomInputRadio,
    ValidationObserver,
    ValidationProvider,
    JsonPreview,
    JobTemplates,
    FormWizard,
    TabContent,
    PopUp,
    Tags,
    EncoderAuthorizationSettings,
  },
  data() {
    return {
      callbackResponse,
      generalInfo,
      infoData: null,
      required,
      alphaDash,
      selectedJobTemplate: null,
      destination: '',
      noDestinations: false,
      callbackUrl: '',
      jsonToPreview: null,
      input_name: '',
      input_class: 1,
      input_type: 1,
      jobTemplateError: false,
      jobTags: [],
      isOpen: false,
      isOpenExternalAccount: false,
      emptyGuid: '00000000-0000-0000-0000-000000000000',
    }
  },
  computed: {
    isJobTemplateSelected() {
      return this.selectedJobTemplate
    },
    creatingLiveJob() {
      return this.$store.state.liveEncoder.creatingLiveJob
    },
    fetchingBuckets() {
      return this.$store.state.buckets.fetchingBuckets
    },
    buckets() {
      return this.$store.state.buckets.buckets
    },
    externalAccounts() {
      return this.$store.state.externalAccount.externalAccounts
    },
    fetchingExternalAccounts() {
      return this.$store.state.externalAccount.fetchingExternalAccounts
    },
    fetchingAccountBuckets() {
      return this.$store.state.accountBuckets.fetchingBuckets
    },
    gettingLiveJobModel() {
      return this.$store.state.liveEncoder.gettingLiveJob
    },
    liveJobModel() {
      return this.$store.state.liveEncoder.liveJob
    },
    wizardActiveTab() {
      return this.$store.state.liveEncoder.wizardActiveTab
    },
    accountBuckets: {
      get() {
        return this.$store.state.accountBuckets.buckets
      },
      set(account) {
        const arr = [{ ...account }]
        this.$store.commit('accountBuckets/UPDATE_BUCKETS', arr)
      },
    },
    selectedAccount: {
      get() {
        return this.$store.state.externalAccount.externalAccount || null
      },
      set(account) {
        this.$store.commit('externalAccount/CHANGE_ACCOUNT', account)
      },
    },
    accountId: {
      get() {
        return this.$store.state.externalAccount.accountId
      },
      set(val) {
        this.$store.commit('externalAccount/SET_ACCOUNT_ID', val)
      },
    },
    selectedBucket: {
      get() {
        return this.$store.state.externalAccount.selectedBucket || null
      },
      set(bucketName) {
        this.$store.commit('externalAccount/CHANGE_BUCKET_NAME', bucketName)
      },
    },
    gjBlob: {
      get() {
        return this.$store.state.liveEncoder.gjBlob
      },
      set(val) {
        this.$store.commit('liveEncoder/SET_GJBLOB', val)
      },
    },
    destinationOptions() {
      return this.buckets.length > 0
        ? this.buckets.map(o => ({ text: o.name, value: o.name }))
        : [{ value: null, text: 'Select' }]
    },
  },
  created() {
    if (this.wizardActiveTab === null || !this.$route.params.backFromJobTemplate) {
      this.getLiveJob()
    }

    this.$store.dispatch('organization/fetchCountries').catch(error => {
      this.errorToast(
          error.response?.data?.errors?.toString() || 'Something went wrong while fetching countries',
      )
    })
  },
  mounted() {
    if (
      this.wizardActiveTab !== null
      && this.$route.params.backFromJobTemplate
    ) {
      this.$refs.liveJobFom.changeTab(0, this.wizardActiveTab)
    }
  },
  methods: {
    getLiveJob() {
      this.$store
        .dispatch('liveEncoder/getLiveJobV2', this.emptyGuid)
        .then(() => {
          this.getAccounts()
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while getting a live job model.',
          )
        })
    },
    setJobTemplate(e) {
      if (!this.selectedJobTemplate || e.id !== this.selectedJobTemplate.id) {
        this.selectedJobTemplate = e
      } else {
        this.selectedJobTemplate = null
      }
    },
    viewJson(a) {
      this.jsonToPreview = a
    },
    openInfo(i) {
      this.infoData = i
    },
    createJob() {
      const tags = []
      this.jobTags.forEach(element => {
        if (element.key !== '' && element.value !== '') {
          tags.push({
            key: element.key,
            value: element.value,
          })
        }
      })
      const query = {
        jobTemplateId: this.selectedJobTemplate.id,
        destination: `${!this.noDestinations ? `${this.selectedBucket}/` : ''}${this.liveJobModel.destination}`,
        description: this.liveJobModel.description,
        bucket: this.selectedBucket,
        record: this.liveJobModel.record,
        recordType: this.liveJobModel.recordType,
        streamType: this.liveJobModel.streamType,
        autoPull: this.liveJobModel.autoPull,
        useRelay: this.liveJobModel.hasRelay,
        input: {
          filePath: this.liveJobModel.input.filePath,
          serverType: this.liveJobModel.input.serverType,
          inputClass: this.liveJobModel.input.inputClass,
          callbackUrl: this.liveJobModel.input.callbackUrl,
        },
        tags,
        storageAccountId: this.accountId,
        playbackAuthorizationEndpoint: this.liveJobModel.playbackAuthorizationEndpoint,
        allowedCountries: this.liveJobModel.allowedCountries,
        disallowedCountries: this.liveJobModel.disallowedCountries,
      }

      this.$store
        .dispatch('liveEncoder/createLiveJobV2', query)
        .then(res => {
          this.onSuccess(res)
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0] || 'An error occurred.',
          )
        })
    },

    validateEncoderSettings() {
      this.jobTemplateError = this.selectedJobTemplate === null
      return new Promise((resolve, reject) => {
        this.$refs.liveJobRules.validate().then(success => {
          if (success && !this.jobTemplateError) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },

    validateInputSettings() {
      return new Promise((resolve, reject) => {
        this.$refs.inputSettingsRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },

    onSuccess(response) {
      const { name } = response.data.result
      this.$router.push({ name: 'live-encoder-settings', params: { name } })
    },
    onCancel() {
      this.$router.push({ name: 'live-encoder' })
    },

    getServerTypeOptions(options) {
      return options.map(o => ({
        text: o.value,
        value: o.id,
        disabled: !o.enabled,
      }))
    },

    onRemoveField(index) {
      this.jobTags = this.jobTags.filter(obj => obj.index !== index)
    },
    createJobTemplate() {
      this.$store.commit(
        'liveEncoder/SET_WIZARD_ACTIVE_TAB',
        this.$refs.liveJobFom.activeTabIndex,
      )
      this.$router.push({
        name: 'job-templates-new',
        query: { from: 'live-jobs' },
      })
    },
    getAccounts() {
      this.$store
        .dispatch('externalAccount/fetchAccounts')
        .then(() => {
          this.changeSelectedAccount(this.selectedAccount)
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors
              || 'Something went wrong while fetching all external accounts.',
          )
        })
    },
    getBuckets() {
      this.$store
        .dispatch('accountBuckets/fetchBuckets', this.accountId)
        .then(() => {
          if (this.selectedAccount?.bucketName != null) {
            this.selectedBucket = this.selectedAccount.bucketName
          } else {
            this.selectedBucket = this.accountBuckets[0]?.name
          }
          this.gjBlob = this.selectedBucket
        })
        .catch(error => {
          this.noDestinations = true
          const { status } = error.response || null
          if (status === 424) {
            this.$store.commit('accountBuckets/SET_SHOW_INTRO', true)
            this.$store.commit('buckets/SET_SHOW_INTRO', true)
            return
          }
          if (status === 426 || status === 428) {
            this.$store.commit('accountBuckets/SET_SERVICE_UNAVAILABLE', status === 428)
            this.$store.commit('buckets/SET_SERVICE_UNAVAILABLE', status === 428)
            return
          }
          if (status === 403) {
            this.hasPermissions = false
            return
          }
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while fetching buckets.',
          )
        })
    },
    changeSelectedBucket(bucket) {
      this.selectedBucket = bucket
    },
    changeSelectedAccount(account) {
      if (account === null) return null
      this.selectedAccount = account
      this.accountId = account?.id || 0
      const bucketName = this.selectedAccount?.bucketName

      // eslint-disable-next-line eqeqeq
      if (!bucketName || this.selectedAccount.parentId == 0) {
        this.getBuckets()
      } else {
        this.accountBuckets = { name: bucketName }
        this.selectedBucket = bucketName
        this.$store.commit('accountBuckets/CANCEL_FETCHING_BUCKETS')
      }

      return this.selectedAccount
    },
    getBucketOptions: options => options.map(o => ({ text: o.name, value: o.name })),
  },
}
</script>
<style lang="scss" scoped>
.hidden {
  opacity: 0;
}
.done-button {
  min-width: 57px;
}
.right-icon {
  position: absolute;
  left: 100%;
  margin-left: 10px;
}
.custom-width::v-deep{
  width: 200px;
  max-width: 200px;

  .dropdown-menu {
    li{
      &:last-child{
        padding-bottom: 10px;
      }
    }
    max-height: 220px;
    overflow-y: auto;
  }
}
.custom-width-input{
  width: 100px;
}
.arrow {
    transform: rotate(180deg);
    transition: 0.2s ease;
}

.arrow-down {
    transform: rotate(0);
    transition: 0.2s ease;
}
.gj-wizard {
  ::v-deep {
    .wizard-tab-container {
      > div {
        margin: auto;
      }
    }
    .card.paper {
      .card-body {
        padding-bottom: 0;
      }
    }

    .info-assistant {
      margin-left: auto;
    }
  }
}

.mr-35 {
  margin-right: 35px;
}

.jobTemplateName {
  width: 100%;
  padding: 12px;
  border-radius: 4px;
}

.blurred {
  filter: blur(5px);
  -webkit-filter: blur(5px);
}

.destination-split {
  display: flex;
  height: 100%;
  padding: 0 15px;
  align-items: center;
  border-left: 1px solid #e0e5eb;
  border-top: 1px solid #e0e5eb;
  border-bottom: 1px solid #e0e5eb;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.destinations::v-deep {
  .dropdown-menu {
    min-width: 200px;
    @media (min-width: 350px) {
      min-width: 300px;
    }
  }
}

.bucket-input::v-deep{
  min-width: 200px;
  .dropdown-menu {
    height: auto;
    max-height: 200px;
    overflow-y: auto;
  }
}

.auto-pull-button{
  margin-top: 10px;
}
</style>
